"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var PreExportedPromotionForecast_1 = require("../model/PreExportedPromotionForecast");

var PreExportedPromotionForecastConverter_1 = require("./PreExportedPromotionForecastConverter");
/**
 * Default implementation of {@link PreExportedPromotionForecastConverter}.
 *
 * @author VRu
 */


var PreExportedPromotionForecastConverterImpl =
/*#__PURE__*/
function (_PreExportedPromotion) {
  _inherits(PreExportedPromotionForecastConverterImpl, _PreExportedPromotion);

  function PreExportedPromotionForecastConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, PreExportedPromotionForecastConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PreExportedPromotionForecastConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PreExportedPromotionForecastConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PreExportedPromotionForecast_1.PreExportedPromotionForecast(PreExportedPromotionForecast_1.PreExportedPromotionForecast.schema.id.valueOf(conversions.documentToClassId(source)), PreExportedPromotionForecast_1.PreExportedPromotionForecast.schema.entityIds.valueOf(source.entityIds.map(conversions.toClassReferenceId)), PreExportedPromotionForecast_1.PreExportedPromotionForecast.schema.state.valueOfField(source), PreExportedPromotionForecast_1.PreExportedPromotionForecast.schema.created.valueOfField(source), this.userInfoConverter.toObject(source.createdBy, conversions), PreExportedPromotionForecast_1.PreExportedPromotionForecast.schema.lastModified.valueOfField(source), PreExportedPromotionForecast_1.PreExportedPromotionForecast.schema.nextAttempt.valueOfField(source), PreExportedPromotionForecast_1.PreExportedPromotionForecast.schema.attemptCount.valueOfField(source), PreExportedPromotionForecast_1.PreExportedPromotionForecast.schema.requestId.valueOfField(source), PreExportedPromotionForecast_1.PreExportedPromotionForecast.schema.error.valueOfField(source), PreExportedPromotionForecast_1.PreExportedPromotionForecast.schema.processId.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        entityIds: source.entityIds.map(conversions.toDocumentReferenceId).toArray()
      });
      Object.assign(result, {
        state: source.state
      });
      Object.assign(result, {
        created: conversions.fromDate(source.created)
      });
      Object.assign(result, {
        createdBy: this.userInfoConverter.toDocument(source.createdBy, conversions)
      });
      Object.assign(result, {
        lastModified: conversions.fromDate(source.lastModified)
      });
      Object.assign(result, {
        nextAttempt: conversions.fromDate(source.nextAttempt)
      });
      Object.assign(result, {
        attemptCount: source.attemptCount
      });
      Object.assign(result, {
        requestId: source.requestId
      });
      Object.assign(result, {
        error: source.error
      });
      Object.assign(result, {
        processId: source.processId
      });
      return result;
    }
  }]);

  return PreExportedPromotionForecastConverterImpl;
}(PreExportedPromotionForecastConverter_1.PreExportedPromotionForecastConverter);

PreExportedPromotionForecastConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], PreExportedPromotionForecastConverterImpl);
exports.PreExportedPromotionForecastConverterImpl = PreExportedPromotionForecastConverterImpl;